/* eslint-disable react/prop-types */
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

import './Select.css'

import React from 'react'
import ReactSelect from 'react-select'
import classNames from 'classnames'

import { responsiveSelect } from '../../ResponsiveSelect'
import Label from '../../Label'


const ResponsiveSelect = responsiveSelect(ReactSelect)


export default function Select({ options, label, className, onChange, value, ...other }) {
  return (
    <div
      className={classNames('selectinput', 'form-group', className)}
    >
      <Label>{label}</Label>
      <div className="forminput">
        <ResponsiveSelect
          className={classNames('react-select')}
          classNamePrefix="react-select"
          options={options}
          getOptionLabel={opt => opt.label }
          getOptionValue={opt => opt.value || ''}
          onChange={val => {
            onChange({ target: { value: val.value } })
          }}
          value={options.find(o => o.value === value)}
          {...other}
        />
      </div>
    </div>
  )
}
